<div class="title">
  აირჩიე დაზღვევის ტიპი
</div>
<form [formGroup]="form">
  <div class="d-flex flex-lg-row flex-md-row flex-direction-sm">
    <div class="hidden-radio">
      <input type="radio" formControlName="type" value="once" id="once"><label for="once">
        ერთჯერადი</label>
    </div>
    <div class="hidden-radio">
      <input type="radio" formControlName="type" value="multiple" id="multiple"><label for="multiple">
        მრავალჯერადი</label>
    </div>
  </div>
  <div *ngIf="form.get('type'); let type;">
    <div class="error-msg error-gender d-block"
    *ngIf="submitted && type.invalid">
    დაზღვევის ტიპი არ არის მონიშნული
    </div>
  </div>
  <div class="sheet-buttons g g--spaceAround g--wrap g--nowrap@s g--alignEnd">
    <app-next-btn (click)="onSubmit()"></app-next-btn>
  </div>
</form>
